// side of dropdown image gallery swiper
var ddBottomSwiper = new Swiper(".dd-swiperBottom", {
  loop: false,
  spaceBetween: 10,
  slidesPerView: 6,
  freeMode: true,
  watchSlidesProgress: true,
  on: {
    init: function () {
      previousActiveIndex = this.activeIndex;
    },
    click: function () {
      if (this.clickedIndex < previousActiveIndex) {
        // console.log("Left");
        this.slideTo(this.clickedIndex - 1, 300, true);
        // console.log(this.clickedIndex - 1);
      } else {
        this.slideTo(this.clickedIndex, 300, true);
      }
      previousActiveIndex = this.clickedIndex;
    },
  },
});

var ddTopSwiper = new Swiper(".dd-swiperTop", {
  loop: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: ddBottomSwiper,
  },
});

// -------------------------------
const bottomDivider = document.querySelector(".pp-grid-parent");
const fixedBannerButton = document.querySelector(".xd-fixed-banner-button");

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting && window.innerWidth <= 768) {
        fixedBannerButton.style.display = "flex";
      } else {
        fixedBannerButton.style.display = "none";
      }
    });
  },
  { threshold: 0 }
);

observer.observe(bottomDivider);

window.addEventListener("resize", () => {
  if (!observer) return;
  if (window.innerWidth < 768) {
    observer.observe(bottomDivider);
  } else {
    observer.unobserve(bottomDivider);
  }
});
// ---------------------------

if (window.innerWidth < 1000) styleTawkFunc();

function styleTawkFunc() {
  const tawkWidgetInterval = setInterval(getTawkWidgetInterval, 1000);
  const clearTawkInterval = setInterval(clearTawkWidgetInterval, 10000);

  function getTawkWidgetInterval() {
    let tawkWidgetVisibleIframe = document.querySelector(".richpanel-micro");

    if (tawkWidgetVisibleIframe) {
      if (!tawkWidgetVisibleIframe.classList.contains("rp-micro-app-hide")) {
        fixedBannerButton.style.justifyContent = "left";
        fixedBannerButton.querySelector("button").style.width = "65%";
        fixedBannerButton.querySelector("button").style.fontSize = "20px";
        clearInterval(tawkWidgetInterval);
      }
    }
  }

  function clearTawkWidgetInterval() {
    clearInterval(tawkWidgetInterval);
    clearInterval(clearTawkInterval);
  }
}
